module.exports = __webpack_public_path__ + "static/img/gyzq.12ee8ae.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/gyzq.png
// module id = GP2g
// module chunks = 3